import { ApiProperty } from '@nestjs/swagger'

export class SubjectExternalSummaryDto {
  @ApiProperty({ type: 'string' })
  id!: string
  @ApiProperty({ type: 'string' })
  label!: string
}
